import { Box, Button, Icon, TextInput, TFText } from '@tf/ui';
import type React from 'react';
import { useState } from 'react';

export const EditableLabel: React.FC<{ initialValue: string; onUpdate: (newValue: string) => void }> = ({
	initialValue,
	onUpdate,
}) => {
	const [isEditing, setIsEditing] = useState(false);
	const [value, setValue] = useState('');

	const _startEditing = () => {
		setValue(initialValue);
		setIsEditing(true);
	};

	const cancelEditing = () => {
		setIsEditing(false);
	};

	const update = () => {
		onUpdate(value);
		setIsEditing(false);
	};

	if (isEditing) {
		return (
			<Box
				sx={{
					width: '100%',
					display: 'flex',
					gap: '4px',
				}}
			>
				<TextInput
					sx={{ flex: 1 }}
					size="xs"
					value={value}
					onChange={(e) => {
						setValue(e.target.value);
					}}
				/>
				<Button size="xs" sx={{ flexShrink: 0 }} variant="subtle" onClick={update}>
					<Icon.IconCheck size={14} />
				</Button>
				<Button size="xs" sx={{ flexShrink: 0 }} variant="subtle" onClick={cancelEditing}>
					<Icon.IconX size={14} />
				</Button>
			</Box>
		);
	}

	return (
		<TFText>
			{initialValue} {/* NOTE: removing editing from enums and structs viewer */}
			{/*<Button*/}
			{/*	size="xs"*/}
			{/*	sx={{ flexShrink: 0, height: 'auto', padding: '2px' }}*/}
			{/*	variant="subtle"*/}
			{/*	onClick={startEditing}*/}
			{/*>*/}
			{/*	<Icon.IconEdit size={14} />*/}
			{/*</Button>*/}
		</TFText>
	);
};
